import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../redux/actions/userActions";
import styles from "./SignIn.module.css";

const SignIn = ({ history }) => {
  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const [phone, setPhone] = useState("");

  useEffect(() => {
    if (userInfo) {
      history.push("/");
    }
  }, [history, userInfo]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(login(phone));
  };
  console.log(userInfo)
  return (
    <div className={styles.container}>
      <header>
        <Link to="/">
          <h1>Uora</h1>
        </Link>
      </header>
      <main>
        <div className={styles.fieldsContainer}>
          <p>Sign in with phone number</p>
          {/* <div className={styles.field}>
                        <label>Select Country</label>
                        <input type="text" name="country" placeholder="Select Country from list" />
                    </div> */}
          <div className={styles.field}>
            <label>Phone Number</label>
            <input
              type="text"
              name="country"
              placeholder="Enter phone number"
              value={phone}
              autoComplete="off"
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
          {/* <Link to="/new-deliveries"> */}
          <button onClick={handleSubmit}>Continue</button>
          {/* </Link> */}
          <small>We'll send OTP for verification</small>
          <Link to="/register">
            <p>Register</p>
          </Link>
          <p>Or continue with</p>
        </div>
        <div className={styles.btnsContainer}>
          <button>Facebook</button>
          <button>Google</button>
        </div>
      </main>
    </div>
  );
};

export default SignIn;
